module.exports = __webpack_public_path__ + "img/c12.02771cb5.png";